<template>
	<div>
		<div>

			<div id="invoice" class="animated fadeIn">
				<div id="invoice-content" class="invoice overflow-auto">
					<div style="width: 100% !important;">
						<header class="container-fluid">
							<div class="row">
								<div class="col-8">
									<div>
										<h1>SNAFINDIA</h1>
									</div>
									<div>83/1, BIDHAN SARANI, SHYAMBAZAR, KOLKATA, W.B.</div>
									<div> PIN - 700004, PHONE: 8100550440, E-MAIL: admin@snafindia.in </div>
								</div>
								<div class="col-4 company-details" style="font-size: 18px;">
									<div class="address"> Voucher No: {{data.id}} </div>
									<div class="email">Date: {{format(data.created_at, "DD/MM/YY hh:mm a")}}</div>
								</div>
								<div class="col-sm-12 text-center"><b style="font-size: 20px;">Receipt Voucher</b></div>
							</div>
						</header>
						<main
							style="padding: 25px; font-size: 18px; margin-top: 10px; border: 1px solid #3989c6; border-radius: 5px;">
							<div class="container-fluid no-gutters">
								<div class="row">
									<div class="col-9 titles">
										<div>
											<span class="title-width"> Received With Thanks From</span>
											 :	&nbsp;	<span style="text-transform: capitalize;">{{data.center_name}}</span>
										</div>
										<div><span class="title-width">Amount</span> :
											&nbsp;	<i class="fa fa-inr"></i> {{data.amount}}	</div>
										<div>
											<span class="title-width">Mode Of Received</span> : &nbsp; 
											<span style="text-transform: capitalize;">{{data.mode}}</span> &nbsp;
										</div>
										<div v-if="data.transaction_id">
											<span class="title-width">Transaction ID</span> : &nbsp; 
											<span style="text-transform: capitalize;">{{ data.transaction_id }}</span>
										</div>
									</div>
									<div v-if="false" class="col-3" style="display: flex; justify-content: end; align-items: flex-end;">
										Received By
									</div>
								</div>
							</div>
						</main>
						<div style="text-align: right; font-size: 14px; color: #aaa; padding-top: 5px;">It is computer generated receipt, doesn't require any signature.</div>
					</div>
					<div></div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
/* eslint-disable no-useless-escape */
/* eslint-disable no-mixed-spaces-and-tabs */


export default {
	data() {
		return {
			data: {},
		}
	},
	async mounted() {
		let id = this.$route.params.id;

		let res = await this.post("fetch-payment-receipt-data", {
			id
		});
		this.data = res.data;
		console.log(this.data);

		window['pageStyle'].innerHTML = `@page {
			margin: 15px;
		}`;


		window.addEventListener('afterprint', this.afterPrint)

		setTimeout(()=>{
			window.print();
		},10)
	},
	methods: {
		print() {
			window.print();
		},
		mobileCheck() {
			let check = false;
			(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
			return check;
		},
		afterPrint() {
			window.removeEventListener('afterprint', this.afterPrint);


			let check = false;
			(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);

			if (!check) this.$router.back();
		}
	}
}
</script>
<style scoped>
@media print {
	.print-hidden {
		display: none;
	}
	#invoice {
		zoom: 80%;
	}
}

@media screen {
	.only-print {
		display: none;
	}
}


#invoice {
	padding: 15px;
}

.titles > div {
	margin-bottom: 25px;
}

.ptable {
	background-color: #eaf4ff;
	border: 1px solid #072f53;

	background: #eee;
	border: 1px solid #444;
	margin: 0 15px;

	border-radius: 8px;
	font-size: 15px;
	/* padding-bottom: 3px; */
	padding: 15px 30px;
	margin-top: 10px;

	font-family: Montserrat;

}

.ptable table {
	margin-bottom: 0;
}

.ptable table tr td {
	padding: 4px 0;
}


.ptable td,
.ptable th {
	border: none;
	padding: 4px 0;
}

.ptable i {
	width: 18px;
	margin-right: 8px;
}

.ptable tr td:nth-child(2n) {
	font-weight: bold;
}

.ptable tr td .fa-play {
	font-size: 12px;
	color: #6394d2;
	color: #8d8d8d;
}

.department {
	text-align: center;
	height: 65px;
}

.department span {
	padding: 12px 20px;
	background: #bbb;
	font-weight: bold;
	font-size: 20px;
	border-radius: 8px;
}
</style>